import React, { useEffect, useState } from "react";
import AutoSave from "../../../components/forms/AutoSave";
import { useDispatch, useSelector } from "react-redux";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormDropdown from "../../../components/forms/FormDropdown";
import {
  setWpsEmail,
  setWpsFirstName,
  setWpsLastName,
  setWpsPhone,
  setWpsDropboxLocation,
  setWpsDropoffDate,
  setWpsCompany,
  setWpsAcgtCard,
  setWpsBillingMethod,
  setWpsPoNumber,
  setWpsPurchasingAgentName,
  setWpsPurchasingAgentEmail,
  setWpsCCName,
  setWpsCCNumber,
  setWpsCCMonth,
  setWpsCCYear,
  setWpsCVV,
  setWpsCardType,
  setWpsShippingOption,
  setWpsDropboxId,
  setWpsGrantNumber,
  setWpsGrantPI,
  setWpsGrantNote,
  setWpsCCZip,
  setWpsOrderAmount,
	setWpsOrderAmountWithDiscount,
	setWpsOrderDiscount,
} from "../../../store";
import Alert from "../../../components/Alert";
import { Link } from "react-router-dom";

import { BostonCaliCorps, germantownAddress, germantownStates, url, usa_states, westcoastStates, westcostAddress, wheelingAddress } from "../../../configlink";
import { Bill } from "../../../components/Bill";

const BillingInformation = ({
  page,
  handleNextPage,
  handlePrevPage,
  progress,
}) => {
  const [poCheck, setPoCheck] = useState(false);
  const billing = useSelector((state) => state.wpsForm.billingInformation);
  const dispatch = useDispatch();

  const wpsWhole = useSelector((state) => state.wpsForm)
  const user = useSelector((state) => state.user.user)
  const dropboxlocations = useSelector((state) => state.user.dropbox)
  const acgtcards = useSelector((state) => state.acgtcard.cards)
    
  let paymentType = useSelector((state) => state.user.paymentType)

  // const token = localStorage.getItem("token");

  const orderAmount = wpsWhole.data.orderAmount 
  const orderAmountWD = wpsWhole.data.orderAmountWithDiscount 

  const handleOptionChange = (option) => {
    setErrors({
      ...errors,
      billingMethod:''
    })
    setAcgtBalanceError(false)
    dispatch(setWpsBillingMethod(option));
  };

  // console.log(user);

  useEffect(() => {
    window.scrollTo(0,200)
  }, [])

	useEffect(() => {
    if(user){
      dispatch(setWpsFirstName(user.FirstName))
      dispatch(setWpsLastName(user.LastName))
      dispatch(setWpsPhone(user.PhoneNumber))
      dispatch(setWpsEmail(user.EmailAddress))
      dispatch(setWpsCompany(user.company))
    }
	}, [])
	
	useEffect(() => {
	if(Number(wpsWhole.data.discountId) > 1){
		//console.log("yes")
		dispatch(setWpsOrderDiscount(null))
		dispatch(setWpsOrderAmountWithDiscount(0))
	}
	}, [])
	
	
	const states = usa_states
	
	let [addressState, setAddressState] = useState('')

	useEffect(() => {

		if(dropboxlocations.length === 0) {
			shipSampleByDefault()
		}
	
		if(user){
			setAddressState(user.State === ''? '' : states.filter(i => i.value === user.State)[0])
		}
	
	}, [])
	
	function showAddress(x){
		return (
			<div className=" w-1/2 ">
				<p className="my-1 text-black">Mail to:</p>
				<div className="bg-green-100 w-full p-2 h-[100px]">
					<p><b>Address:</b></p>
					<p className="whitespace-pre-line">{germantownStates.includes(x) ? wheelingAddress : westcoastStates.includes(x) ? westcostAddress : wheelingAddress}</p>
				</div>
			</div>
		)
	}
	
	const shipSampleTemplate = () => {
		return (
			BostonCaliCorps.includes(user.CorporateId) ?
			<p className="mt-2 text-red-600 p-2">*Free shipping via FedEx is available for orders of 10 or more WPS samples. Please email us at <a className="underline" href="mailto:wps@acgtinc.com">wps@acgtinc.com</a> to request a label. You must include the order confirmation number, the sending address, and a phone number to use to generate the label.</p>
			:
			<p className="mt-2 text-red-600 p-2">*Free shipping via FedEx is available for orders of 15 or more WPS samples. Please email us at <a className="underline" href="mailto:wps@acgtinc.com">wps@acgtinc.com</a> to request a label. You must include the order confirmation number, the sending address, and a phone number to use to generate the label.</p>
		)
	}
	
	
  const handleSelectCardType = (card) => {
    setErrors({
      ...errors,
      ccError: ''
    })
    dispatch(setWpsCardType(card));
  };

  let [dropboxOption, setDropboxOption] = useState(billing.shippingOption === 'Dropbox'? true: false)
  let [acgtBalanceError, setAcgtBalanceError] = useState(false)

  const handleShippingOption = (option) => {
    if(option === 'Ship sample'){
      // console.log("self");
      setDropboxOption(false)
      setErrors({
        ...errors,
        dropboxLocation: '',
        dropoffDate:''
      })
    }
    else{
      setDropboxOption(true)
    }
    dispatch(setWpsShippingOption(option));
  };

  // console.log(billing);

  const isWeekend = (val) => {
    // console.log("val", val);
    const day = val.getUTCDay();
    if (day === 6 || day === 0) {
      return true
    } else {
      return false
    }
  }

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    // if (!billing.firstName) newErrors.firstName = 'Please enter';
    // if (!billing.lastName) newErrors.lastName = 'Please enter';
    // if (!billing.phone) {
    //   newErrors.phone = "Please enter phone number";
    // } else if (!/^\d{3}-\d{3}-\d{4}$/i.test(billing.phone) && !/^\d{10}$/i.test(billing.phone)) {
    //   newErrors.phone = "Please enter a valid phone number";
    // }
    // if (!billing.email) {
    //   newErrors.email = 'Please enter email address';
    // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(billing.email)) {
    //   newErrors.email = 'Please enter a valid email address';
    // }
    
    if(billing.shippingOption === "Dropbox" && !billing.dropboxLocation) newErrors.dropboxLocation = 'Please select'
	
	// if(billing.shippingOption === "Ship sample" && !addressState) newErrors.addressState = 'Please select'
	
    if(billing.shippingOption === "Dropbox" && !billing.dropoffDate){
      newErrors.dropoffDate = 'Please select'
    } 
    else if(billing.shippingOption === "Dropbox" && new Date(billing.dropoffDate) < minDate) {
      newErrors.dropoffDate = 'Drop-off date cannot be prior to today'
    } 
    else if(billing.shippingOption === "Dropbox" && isWeekend(new Date(billing.dropoffDate))) {
      newErrors.dropoffDate = 'Please select a weekday'
    }
    
    if(!billing.billingMethod) newErrors.billingMethod = 'Please select one'

    if(billing.billingMethod === 'Credit Card' && (!billing.cardType || !billing.ccNumber || !billing.ccName || !billing.ccMonth || !billing.ccYear || !billing.cvv || !billing.ccZip)) {
      newErrors.ccError = 'Please enter all the details'
    }
    else if(billing.billingMethod === 'Credit Card' && (parseInt(billing.ccMonth) < 1 || parseInt(billing.ccMonth) > 12)){
      newErrors.ccError = 'Please enter month value from 1 to 12'
    }
    else if(billing.billingMethod === 'Credit Card' && isExpired(`${billing.ccMonth}/${billing.ccYear}`, minCcMonth)){
      newErrors.ccError = 'Credit card is expired'
    }

    // if(billing.billingMethod === 'P.O. Number' && ((!billing.poNumber && !poCheck) || !billing.purchasingAgentEmail || !billing.purchasingAgentName)) {
    //   newErrors.poError = 'Please enter all the details'
    // }
    if(billing.billingMethod === 'P.O. Number' && ((!billing.poNumber && !poCheck))) {
      newErrors.poError = 'Please enter P.O. Number'
    } else if (billing.billingMethod === 'P.O. Number' && poCheck && (!billing.purchasingAgentEmail || !billing.purchasingAgentName)){
      newErrors.poError = 'Please enter the details'
    }

    if(billing.billingMethod === 'ACGT Card' && (!billing.acgtCard)) {
      newErrors.acgtSelectError = 'Please select'
    }

    if(billing.billingMethod === 'Grant' && (!billing.grantNumber || !billing.grantPi)) {
      newErrors.grantError = 'Please enter all the details'
    }



    return {newErrors: newErrors}


  };

  let [requiredBalance, setRequiredBalance] = useState(0)

  const validateBilling = async () => {
    const validationErrors = validate();
    // console.log("here",validationErrors);
      if (Object.keys(validationErrors.newErrors).length > 0){
        setErrors(validationErrors.newErrors);
      }
      else if(billing.billingMethod === 'ACGT Card'){
        // console.log(acgtcards);
        
        let getBalance = await getAcgtCardBalance(billing.acgtCard)
        // console.log("balance", getBalance);
        
        if(getBalance !== undefined){
          if(Number(orderAmountWD) > 0){
            let amt2 = Number(orderAmountWD)
             if(getBalance > amt2){
                handleNextPage()
              }
              else {
                let reqBln = amt2 - parseFloat(getBalance)
                // console.log(reqBln);
                setRequiredBalance(reqBln)
                setAcgtBalanceError(true)
              } 
          }
          else {
              if(getBalance > orderAmount){
                handleNextPage()
              }
              else {
                let reqBln = orderAmount - parseFloat(getBalance)
                // console.log(reqBln);
                setRequiredBalance(reqBln)
                setAcgtBalanceError(true)
              } 
          }
        }
        else{
          alert('Select ACGT card')
        }
      }
      else {
        handleNextPage()
      }
  }

  async function getAcgtCardBalance(x) {
    // console.log(x);

    let balanceAmt = 
      await fetch(`${url}/api/acgtcard/balance?cardId=${x}`, {
        method: 'GET',
        credentials: 'include',
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // }
      })
      .then(res => res.json())
      .then(data => {
        // console.log('balance', data);
        return data.result[0].amt
      }) 
    
      return balanceAmt
   

  }

  //price calc
  let prices = useSelector((state)=> state.user.prices)
  

  
  let total = orderAmount



  // console.log(acgtcards);
  
  
  const cardOptions = acgtcards

  const [minDate, setMinDate] = useState('');
  const [minCcMonth, setMinCcMonth] = useState('')


  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    setMinDate(`${year}-${month}-${day}`);
    dispatch(setWpsDropoffDate(`${year}-${month}-${day}`))
    setMinCcMonth(`${month}/${year}`)
  }, []);

  function isExpired(enteredDate, currentMonth) {
    // Split enteredDate and currentMonth into MM and YYYY
    const [enteredMonth, enteredYear] = enteredDate.split('/').map(Number);
    const [currentMonthValue, currentYear] = currentMonth.split('/').map(Number);
  
    // Compare the year first
    if (enteredYear < currentYear) {
      return true; // Expired
    } else if (enteredYear === currentYear) {
      // If the year is the same, compare the month
      return enteredMonth < currentMonthValue;
    }
  
    return false; // Not expired
  }


  function shipSampleByDefault(){
    dispatch(setWpsShippingOption("Ship sample"))
  }

  // console.log(billing);
  
  let [draftSuccess,setDraftSuccess] = useState(false)

  const passMessage = (message) => {
    // console.log("message");
    
    if(message === 'success'){
      window.scrollTo({top:200, left:0, behavior:'smooth'})
      setDraftSuccess(true)
      setTimeout(() => {
        setDraftSuccess(false)
      }, 5000)
    }
    else if(message === 'failure'){
      alert("Something went wrong..")
    }
  }

  function changePrice(x){
      // dispatch(setWpsOrderAmount(x))
      // console.log(x);
      dispatch(setWpsOrderAmountWithDiscount(x))
      
    }
  

  const disabledInput = poCheck
    ? "border-2 border-[#D5D5D8] bg-[var(--color-secondary-gray)] rounded-sm pointer-events-none w-full py-1 px-4"
    : "border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4";

  return (
    <>
      <div className='px-8 xl:px-16'>
        <h1 className='text-3xl xl:text-4xl text-[var(--color-primary-purple)] font-black my-[40px]'>
			Whole Plasmid Sequencing
        </h1>
        {draftSuccess && 
          <div className="mb-3">
            <Alert type="success">
              <span className="whitespace-nowrap">Form successfully saved to drafts. You can find your saved drafts by going to <Link to="/orderhistory" className="underline">My Orders.</Link></span>
            </Alert>
          </div>
          }
        <div className="w-full overflow-hidden">
          {progress}
          </div>
        <div className='flex justify-between w-full'>
          <div className='w-[48%]'>
            <p className='text-2xl text-[var(--color-primary-purple)] font-black border-b-2 pb-3 border-[var(--color-primary-purple)] mt-10 mb-6 '>
              Information
            </p>
            <div className='grid grid-cols-2'>
              <div className='col-span-1 my-4'>
                <div className='flex justify-between'>
                  <label className='text-lg font-black text-[var(--color-primary-purple)] mb-3'>
                    Name
                  </label>
                </div>
                <div>
                  <div className='flex gap-[30px]'>
                    <div className="w-1/2">
                      <input
                        type='text'
                        placeholder='First name'
                        className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 mr-4 text-[var(--color-primary-gray)] h-10 focus:outline-none w-full'
                        value={billing.firstName}
                        disabled
                        // onChange={(event) => {
                        //   setErrors({
                        //     ...errors,
                        //     firstName:''
                        //   })
                        //   handleFirstName(event.target.value)}
                        // } 
                      />
                       {errors.firstName && <span className="text-[14px] text-red-500 font-bold">{errors.firstName}</span>}
                    </div>
                    <div className="w-1/2">
                      <input
                        type='text'
                        placeholder='Last name'
                        className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 text-[var(--color-primary-gray)] h-10 focus:outline-none w-full'
                        value={billing.lastName}
                        disabled
                        // onChange={(event) => {
                        //   setErrors({
                        //     ...errors,
                        //     lastName:''
                        //   })
                        //   handleLastName(event.target.value)}
                        // } 
                      />
                      {errors.lastName && <span className="text-[14px] text-red-500 font-bold">{errors.lastName}</span>}
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex flex-col col-span-1 my-4 ml-6'>
                <label className='text-lg  font-black text-[var(--color-primary-purple)] mb-3'>
                  Company
                </label>
                <input
                  type='text'
                  placeholder='Company'
                  className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 text-[var(--color-primary-gray)] h-10 focus:outline-none'
                  value={billing.company}
                  disabled
                  // onChange={(event) => {
                  //   handleCompany(event.target.value)}
                  // } 
                />
              </div>
            </div>
            <div className='grid grid-cols-2'>
              <div className='col-span-1 my-4'>
                <div className='flex justify-between'>
                  <label className='text-lg  font-black text-[var(--color-primary-purple)] mb-3'>
                    Phone
                  </label>
                </div>
                <input
                  type='text'
                  placeholder='Phone number'
                  className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 text-[var(--color-primary-gray)] w-full h-10 focus:outline-none'
                  value={billing.phone}
                  disabled
                  // onChange={(event) => {
                  //   setErrors({
                  //     ...errors,
                  //     phone:''
                  //   })
                  //   handlePhone(event.target.value)}
                  // } 
                />
                 {errors.phone && <span className="text-[14px] text-red-500 font-bold">{errors.phone}</span>}
              </div>
              <div className='col-span-1 my-4 ml-6'>
                <div className='flex justify-between'>
                  <label className='text-lg  font-black text-[var(--color-primary-purple)] mb-3'>
                    Email
                  </label>
                </div>
                <input
                  type='text'
                  placeholder='Email Address'
                  className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 text-[var(--color-primary-gray)] w-full h-10 focus:outline-none'
                  value={billing.email}
                  disabled
                  // onChange={(event) => {
                  //   setErrors({
                  //     ...errors,
                  //     email:''
                  //   })
                  //   handleEmail(event.target.value)}
                  // } 
                />
                 {errors.email && <span className="text-[14px] text-red-500 font-bold">{errors.email}</span>}
              </div>
            </div>
          </div>
          {dropboxlocations.length > 0 ? 
            <div className='w-[48%]'>
              <p className='text-2xl text-[var(--color-primary-purple)] font-black border-b-2 pb-3 border-[var(--color-primary-purple)] mt-10 mb-6 '>
                Sample Shipping
              </p>
              <div className='flex flex-col'>
                <div className='flex items-center'>
                  <input
                    type='radio'
                    id='dropbox'
                    name='shipping'
                    checked={billing.shippingOption === "Dropbox"}
                    onChange={() => handleShippingOption("Dropbox")}
                    className='m-2 h-5 w-5 accent-[var(--color-primary-purple)] cursor-pointer'
                  />
                  <label htmlFor='dropbox' className=' font-bold 1 mr-5'>
                    Drop-off at dropbox
                  </label>
                </div>
                {dropboxOption && <>
                  <div className='grid grid-cols-2'>
                    <div className='col-span-1 my-4'>
                      <div className='mb-3'>
                        <label className='text-lg font-black text-[var(--color-primary-purple)]'>
                          Dropbox Location
                        </label>
                      </div>

                      <div className='border-2 border-[var(--color-primary-purple)] h-10'>
                        <FormDropdown
                          options={dropboxlocations.map(x => {
                            return {label: x.building, id: x.dropBoxId}
                          }
                          )}
                          onSelect={(option) => {
                            // console.log(option)
                            setErrors({
                              ...errors,
                              dropboxLocation:''
                            })
                            dispatch(setWpsDropboxId(option.id))
                            dispatch(setWpsDropboxLocation(option))
                          }
                          }
							selectedOption={billing.dropboxLocation}
							type={2}
                        />
                      {errors.dropboxLocation && <span className="text-[14px] text-red-500 font-bold">{errors.dropboxLocation}</span>}
                      </div>
                    </div>
                    <div className='flex flex-col col-span-1 my-4 ml-6'>
                      <label className='text-lg font-black text-[var(--color-primary-purple)] mb-3'>
                        Drop-off Date
                      </label>
                        <input className="border-2 border-[var(--color-primary-purple)] h-10 p-2" 
                          type="date" 
                          name="dropoffdate" 
                          id="dropoffdate" 
                          min={minDate}
                          value={billing.dropoffDate}
                          onChange={(event) =>{
                            // console.log(event.target.value)
                            setErrors({
                              ...errors,
                              dropoffDate:''
                            })
                            dispatch(setWpsDropoffDate(event.target.value))
                          }
                          }
                        />
                        {errors.dropoffDate && <span className="text-[14px] mt-1 text-red-500 font-bold">{errors.dropoffDate}</span>}
                    </div>
					</div>
					{billing.dropboxLocation && 
						<div className="bg-green-100 w-full p-3 mb-1">
							<p className=""><b>Address:</b> {dropboxlocations.find(x => Number(x.dropBoxId) === Number(wpsWhole.data.dropBoxId)).address !== '' ? dropboxlocations.find(x => Number(x.dropBoxId) === Number(wpsWhole.data.dropBoxId)).address : 'N/A'}</p>
							<p className="mt-2"><b>Pickup time:</b> {dropboxlocations.find(x => Number(x.dropBoxId) === Number(wpsWhole.data.dropBoxId)).pickUpTime !== '' ? dropboxlocations.find(x => Number(x.dropBoxId) === Number(wpsWhole.data.dropBoxId)).pickUpTime : 'N/A'}</p>
						</div>
					}
					<p className="mt-1 text-red-600">Sample(s) must be dropped off at this dropbox location on the above date prior to the pickup time. If you are unable to meet this cutoff time you must notify us at <a className="underline" href="mailto:dropbox@acgtinc.com">dropbox@acgtinc.com</a>.</p>
                </>}
                <div className='flex items-center mt-4'>
                  <input
                    type='radio'
                    id='ship'
                    name='shipping'
                    checked={billing.shippingOption === "Ship sample"}
                    onChange={() => handleShippingOption("Ship sample")}
                    className='m-2 h-5 w-5 accent-[var(--color-primary-purple)] cursor-pointer'
                  />
                  <label htmlFor='ship' className=' font-bold'>
                    Send by self
                  </label>
				</div>
				{billing.shippingOption === "Ship sample" && 
					shipSampleTemplate()
				}
              </div>
            </div>
            :
			<div className='w-[48%]'>
				<p className='text-2xl text-[var(--color-primary-purple)] font-black border-b-2 pb-3 border-[var(--color-primary-purple)] mt-10 mb-6 '>
					Sample Shipping
				</p>
				<div className='flex flex-col'>
					<div>
						<div className='flex items-center'>
							<input
								type='radio'
								id='dropbox'
								name='shipping'
								disabled
								className='m-2 h-5 w-5 accent-[var(--color-primary-purple)] pointer-events-none'
							/>
							<label htmlFor='dropbox' className=' font-bold 1 mr-5 text-gray-400'>
								Drop-off at dropbox
							</label>
						</div>
						<p className="mt-2 text-red-600 px-2 mb-4">No dropbox is available at your institution. To request a dropbox contact us at <a className="underline" href="https://docs.google.com/forms/d/e/1FAIpQLSfnq8uLciCy0pTuMAQNOuI4-HIbrNWLiXPVhjxJQlIW1eM9lg/viewform?pli=1" target="_blank" rel="noreferrer">Dropbox Request Form</a>.</p>
					</div>
					<div className='flex items-center '>
						<input
						type='radio'
						id='ship'
						name='shipping'
						checked
						className='m-2 h-5 w-5 accent-[var(--color-primary-purple)] cursor-pointer'
						/>
						<label htmlFor='ship' className=' font-bold'>
							Send by self
						</label>
					</div>
				
					{billing.shippingOption === "Ship sample" && 
						shipSampleTemplate()
					}
				
				</div>
			
			</div>
          }
        </div>

        <div className=' mt-14 mb-4'>
          <p className='col-span-1 text-2xl text-[var(--color-primary-purple)] font-bold border-b-2 pb-3 border-[var(--color-primary-purple)] my-4 '>
            Billing Information
          </p>
          <p className="text-[18px]">Please review our <a href="/forms/ACGT_Payment-Options.pdf" download className="text-[var(--color-primary-purple)] font-bold underline">Payment Options</a> for detailed information.</p>
        </div>
        {/* Payment Container */}
        <div>
           
          {paymentType.grant === true ? 
          <>
            <div className='flex items-center bg-[var(--color-secondary-gray)] border-[1px] border-gray-500'>
            <input
              type='radio'
              id='option1'
              name='options'
              value='option1'
              checked={billing.billingMethod === "Grant"}
              onChange={() => handleOptionChange("Grant")}
              className='w-5 h-5 mx-[18px] cursor-pointer'
            />
            <label
              htmlFor='option1'
              className='text-md text-[var(--color-primary-gray)] uppercase  font-black py-4 cursor-pointer'
            >
              Grant
            </label>
            </div>

            {billing.billingMethod === "Grant" && (
              <div className='flex justify-between h-full px-[60px] border-1 border-gray-300'>
                <div className='flex flex-col justify-between justify-items-start w-[70%] mr-[60px] my-6'>
                  <div className='flex flex-col items-start'>
                    <label
                      htmlFor='ponumber'
                      className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                    >
                      Grant Number
                    </label>
                    <input
                      type='text'
                      id='grantnumber'
                      className={disabledInput}
                      value={billing.grantNumber}
                      placeholder="Grant Number"
                      onChange={(event) => {
                        setErrors({
                          ...errors,
                          grantError:''
                        })
                        event.target.value = event.target.value.replace(/[^0-9-]/g, '');
                        dispatch(setWpsGrantNumber(event.target.value))
                      }
                      }
                    />
                  </div>
                  <div className='flex flex-col items-start'>
                    <label
                      htmlFor='ponumber'
                      className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                    >
                      Grant PI
                    </label>
                    <input
                      type='text'
                      id='grantpi'
                      className={disabledInput}
                      value={billing.grantPi}
                      placeholder="Grant PI"
                      onChange={(event) => {
                        setErrors({
                          ...errors,
                          grantError:''
                        })
                        dispatch(setWpsGrantPI(event.target.value))
                      }
                      }
                    />
                  </div>
                  <div className='flex flex-col items-start'>
                    <label
                      htmlFor='ponumber'
                      className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                    >
                      Grant Note
                    </label>
                    <input
                      type='text'
                      id='grantnote'
                      className={disabledInput}
                      value={billing.grantNote}
                      placeholder="Note"
                      onChange={(event) => {
                        dispatch(setWpsGrantNote(event.target.value))
                      }
                      }
                    />
                  </div>
                  
                {errors.grantError && <span className="text-[14px] text-red-500 font-bold mt-2">{errors.grantError}</span>}
                </div>
              </div>
            )}
          </>
          :
          <>
            
            <>
              <div className='flex items-center bg-[var(--color-secondary-gray)] border-[1px] border-gray-500'>
              <input
                type='radio'
                id='option1'
                name='options'
                value='option1'
                checked={billing.billingMethod === "P.O. Number"}
                onChange={() => handleOptionChange("P.O. Number")}
                className='w-5 h-5 mx-[18px] cursor-pointer'
              />
              <label
                htmlFor='option1'
                className='text-md text-[var(--color-primary-gray)] uppercase  font-black py-4 cursor-pointer'
              >
                P.O. NUMBER / STANDING P.O. NUMBER
              </label>
              </div>

              {billing.billingMethod === "P.O. Number" && (
                <div className='flex justify-between h-full px-[60px] border-1 border-gray-300 pb-[20px]'>
                  <div className='flex flex-col justify-between justify-items-start w-[50%] xl:w-[70%] mr-[60px] my-6'>
                    <div className='flex flex-col items-start'>
                      <label
                        htmlFor='ponumber'
                        className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                      >
                        P.O. Number
                      </label>
                      <input
                        type='text'
                        id='ponumber'
                        className={disabledInput}
                        value={billing.poNumber}
                        onChange={(event) => {
                          setErrors({
                            ...errors,
                            poError:''
                          })
                          dispatch(setWpsPoNumber(event.target.value))
                        }
                        }
                      />
                      <div className='flex justify-start items-end xl:w-[48%]'>
                        <input
                          type='checkbox'
                          id='myCheckbox'
                          checked={poCheck}
                          onChange={() => {
                            setErrors({
                              ...errors,
                              poError:''
                            })
                            setPoCheck(!poCheck)}}
                          className='hidden'
                        />
                        <label
                          htmlFor='myCheckbox'
                          className='cursor-pointer flex items-center'
                        >
                          <div
                            className={` border border-[var(--color-primary-purple)] w-6 h-6 flex items-center justify-center rounded-md focus-within:border-[var(--color-primary-purple)] ${
                              poCheck
                                ? "bg-[var(--color-primary-purple)]"
                                : "bg-white"
                            }`}
                          >
                            {/* Custom checkbox design */}
                            {poCheck && (
                              <svg
                                className='w-15 h-15 text-white'
                                fill='none'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth='2'
                                viewBox='0 0 24 24'
                                stroke='currentColor'
                              >
                                <path d='M6 12l4 4 6-10'></path>
                              </svg>
                            )}
                          </div>
                          <span className='m-2 text-[#1F1F1F] font-medium'>
                            P.O. Number not available or will provide later
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className='flex flex-col'>
                      <label
                        htmlFor='paname'
                        className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                      >
                        Purchasing Agent Name <span className="text-gray-500 text-[14px]">{poCheck ? '':' (Optional)'}</span>
                      </label>
                      <input
                        type='text'
                        id='paname'
                        className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                        placeholder='Name'
                        value={billing.purchasingAgentName}
                        onChange={(event) => {
                          setErrors({
                            ...errors,
                            poError:''
                          })
                          dispatch(setWpsPurchasingAgentName(event.target.value))
                        }
                        }
                      />
                    </div>
                    <div className='flex flex-col'>
                      <label
                        htmlFor='paemail'
                        className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                      >
                        Purchasing Agent Email <span className="text-gray-500 text-[14px]">{poCheck ? '':' (Optional)'}</span>
                      </label>
                      <input
                        type='text'
                        id='paemail'
                        className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                        placeholder='Email address'
                        value={billing.purchasingAgentEmail}
                        onChange={(event) => {
                          setErrors({
                            ...errors,
                            poError:''
                          })
                          dispatch(setWpsPurchasingAgentEmail(event.target.value))
                        }
                        }
                      />
                      {errors.poError && <span className="text-[14px] text-red-500 font-bold mt-2">{errors.poError}</span>}
                    </div>
                  </div>
                  <div className='w-[40%] xl:w-[30%] mt-10'>
                    <div className='border-2 border-[#D5D5D8] bg-[var(--color-secondary-gray)] p-6'>
                      <div className='mb-4'>
                        <span className=' font-black text-[var(--color-primary-gray)]'>
                          A Purchase Order (P.O.) Number
                        </span>
                        <span className='text-[var(--color-primary-gray)] font-bold'>
                          {" "}
                          is a buyer-generated number that authorizes a one time
                          purchase of service.
                        </span>
                      </div>
                      <div>
                        <span className=' font-black text-[var(--color-primary-gray)]'>
                          A Standing P.O. Number
                        </span>
                        <span className='text-[var(--color-primary-gray)] font-bold'>
                          {" "}
                          is a Purchase Order which has been issued to a vendor,
                          against which purchase of services may be made for a
                          specified period of time or for a specified dollar amount.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          
            <>
              <div className='flex items-center bg-[var(--color-secondary-gray)] border-[1px] border-gray-500'>
              <input
                type='radio'
                id='option2'
                name='options'
                value='option2'
                checked={billing.billingMethod === "Credit Card"}
                onChange={() => handleOptionChange("Credit Card")}
                className='w-5 h-5 mx-[18px] cursor-pointer'
              />
              <label
                htmlFor='option2'
                className='text-md text-[var(--color-primary-gray)] uppercase  font-black py-4 cursor-pointer '
              >
                CREDIT CARD
              </label>
              </div>

              {billing.billingMethod === "Credit Card" && (
                <div className='flex justify-between h-full px-[60px] border-1 border-gray-300'>
                  <div className='flex flex-col justify-between justify-items-start w-[70%] my-6'>
                    <div className='flex flex-col '>
                      <label
                          htmlFor='cardtype'
                          className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                        >
                        Card Type <span className="font-normal italic text-black">(pick one) </span> 
                      </label>
                      <div className='flex justify-between w-1/3 gap-[10px]'>
                        <img
                          src='/images/Visa.png'
                          alt='visa'
                          className={`w-28 ${billing.cardType === "Visa"?'':'filter grayscale'} h-auto cursor-pointer`}
                          onClick={() => handleSelectCardType("Visa")}
                        />
                        <img
                          src='/images/Mastercard.png'
                          alt='mastercard'
                          className={`w-28  ${billing.cardType === "Mastercard"?'':'filter grayscale'} h-auto cursor-pointer`}
                          onClick={() => handleSelectCardType("Mastercard")}
                        />
                        <img
                          src='/images/Discover.png'
                          alt='discover'
                          className={`w-28  ${billing.cardType === "Discover"?'':'filter grayscale'} h-auto cursor-pointer`}
                          onClick={() => handleSelectCardType("Discover")}
                        />
                        <img
                          src='/images/ACGT_American Express.png'
                          alt='american express'
                          className={`w-28  ${billing.cardType === "American Express"?'':'filter grayscale'} h-auto cursor-pointer`}
                          onClick={() => handleSelectCardType("American Express")}
                        />
                      </div>
                    </div>
                    <div className='flex flex-col '>
                      <label
                        htmlFor='name'
                        className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                      >
                        Name on Card
                      </label>
                      <input
                        type='text'
                        id='name'
                        className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                        placeholder='Name'
                        value={billing.ccName}
                        onChange={(event) => {
                          setErrors({
                            ...errors,
                            ccError: ''
                          })
                          dispatch(setWpsCCName(event.target.value))
                        }
                        }
                      />
                    </div>
                    <div className='flex flex-col'>
                      <label
                        htmlFor='number'
                        className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                      >
                        Card Number
                      </label>
                      <input
                        type='text'
                        id='number'
                        className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                        placeholder='XXXX-XXXX-XXXX-XXXX'
                        value={billing.ccNumber}
                        onChange={(event) => {
                          setErrors({
                            ...errors,
                            ccError: ''
                          })

                          event.target.value = event.target.value.replace(/\D/g, "");

                          if (event.target.value.length > 16) {
                            event.target.value = event.target.value.slice(0, 16);
                          }

                          dispatch(setWpsCCNumber(event.target.value))
                        }
                        }
                      />
                    </div>
                    <div className='flex justify-between'>
                      <div className='flex flex-col'>
                        <label
                          htmlFor='month'
                          className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                        >
                          Month
                        </label>
                        <input
                          type='text'
                          id='month'
                          className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                          placeholder='MM'
                          value={billing.ccMonth}
                          maxLength={2}
                          onChange={(event) => {
                            setErrors({
                              ...errors,
                              ccError: ''
                            })

                            event.target.value = event.target.value.replace(/\D/g, "");

                            if (event.target.value.length > 2) {
                              event.target.value = event.target.value.slice(0, 2);
                            }

                            dispatch(setWpsCCMonth(event.target.value))
                          }
                          }
                        />
                      </div>
                      <div className='flex flex-col'>
                        <label
                          htmlFor='year'
                          className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                        >
                          Year
                        </label>
                        <input
                          type='text'
                          id='year'
                          className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                          placeholder='YYYY'
                          maxLength={4}
                          value={billing.ccYear}
                          onChange={(event) => {
                            setErrors({
                              ...errors,
                              ccError: ''
                            })

                            event.target.value = event.target.value.replace(/\D/g, "");

                            if (event.target.value.length > 4) {
                              event.target.value = event.target.value.slice(0, 4);
                            }

                            dispatch(setWpsCCYear(event.target.value))
                          }
                          }
                        />
                      </div>
                      <div className='flex flex-col'>
                        <label
                          htmlFor='cvv'
                          className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                        >
                          CVV
                        </label>
                        <input
                          type='text'
                          id='cvv'
                          className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                          placeholder='XXX'
                          maxLength={4}
                          value={billing.cvv}
                          onChange={(event) => {
                            setErrors({
                              ...errors,
                              ccError: ''
                            })

                            event.target.value = event.target.value.replace(/\D/g, "");

                            if (event.target.value.length > 4) {
                              event.target.value = event.target.value.slice(0, 4);
                            }

                            dispatch(setWpsCVV(event.target.value))
                          }
                          }
                        />
                      </div>
                      <div className='flex flex-col'>
                        <label
                          htmlFor='year'
                          className=' text-lg text-[var(--color-primary-purple)] font-black my-2'
                        >
                          Zip
                        </label>
                        <input
                          type='text'
                          id='zip'
                          className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                          placeholder='Zip Code'
                          maxLength={5}
                          value={billing.ccZip}
                          onChange={(event) => {
                            setErrors({
                              ...errors,
                              ccError: ''
                            })

                            event.target.value = event.target.value.replace(/\D/g, "");

                            if (event.target.value.length > 5) {
                              event.target.value = event.target.value.slice(0, 5);
                            }

                            dispatch(setWpsCCZip(event.target.value))
                          }
                          }
                        />
                      </div>
                    </div>
                  {errors.ccError && <span className="text-[14px] text-red-500 font-bold mt-2">{errors.ccError}</span>}
                  </div>
                </div>
              )}
            </>
      
            {cardOptions.length > 0 && 
              <>
                <div className='flex items-center bg-[var(--color-secondary-gray)] border-[1px] border-gray-500'>
                <input
                  type='radio'
                  id='option3'
                  name='options'
                  value='option3'
                  checked={billing.billingMethod === "ACGT Card"}
                  onChange={() => handleOptionChange("ACGT Card")}
                  className='w-5 h-5 mx-[18px] cursor-pointer'
                />
                <label
                  htmlFor='option3'
                  className='text-md text-[var(--color-primary-gray)] uppercase  font-black py-4 cursor-pointer '
                >
                  ACGT CARD
                </label>
                </div>

                {billing.billingMethod === "ACGT Card" && (
                  <div className='flex justify-between h-full px-[60px] border-1 border-gray-300'>
                    <div className='flex flex-col justify-between justify-items-start w-[50%] my-6'>
                      <label className=' text-lg text-[var(--color-primary-purple)] font-black my-2'>
                        Select Card
                      </label>
                      <select
                        value={billing.acgtCard}
                        onChange={(event) => {                   
                          setAcgtBalanceError(false)
                          setErrors({
                            ...errors,
                            acgtSelectError: ''
                          })
                          dispatch(setWpsAcgtCard(event.target.value))
                        }
                        }
                        placeholder='Select Card'
                        className='border-2 border-[var(--color-primary-purple)] rounded-sm w-full py-1 px-4'
                      >
                        <option value='' disabled hidden>
                          Select Card
                        </option>
                        {cardOptions.map((option) => (
                          <option key={option} value={option.id}>
                            {option.cardnumber}
                          </option>
                        ))}
                      </select>
                        {acgtBalanceError && 
                          <>
                          <div className="flex flex-col mt-[10px]">
                            <span className="text-[14px] text-red-500 font-bold uppercase">Insufficient balance..</span>
                            <span className="text-[14px] font-bold">{`Balance on your ACGT card: $${orderAmount - requiredBalance}`}</span>
                            <span className="text-[14px] font-bold">{`Order total price: $${orderAmount}`}</span>
                            <span className="text-[14px] font-bold">{`Please refill your ACGT card with a miminum of $${requiredBalance} or select a different payment method`}</span>
                            
                          </div>
                          </>
                        }
                        {errors.acgtSelectError && <span className="text-[14px] text-red-500 font-bold mt-2">{errors.acgtSelectError}</span>}
                    </div>
                  </div>
                )}
              </>
            }
          
            <>
              <div className='flex items-center bg-[var(--color-secondary-gray)] border-[1px] border-gray-500'>
              <input
                type='radio'
                id='option4'
                name='options'
                value='option4'
                checked={billing.billingMethod === "Purchasing Agent"}
                onChange={() => handleOptionChange("Purchasing Agent")}
                className='w-5 h-5 mx-[18px] cursor-pointer'
              />
              <label
                htmlFor='option4'
                className='text-md text-[var(--color-primary-gray)] uppercase  font-black py-4 cursor-pointer '
              >
                PURCHASING AGENT
              </label>
              </div>

              {billing.billingMethod === "Purchasing Agent" && (
                <div className='flex h-full justify-start px-[60px] border-1 border-gray-300'>
                  <div className='w-[40%] my-6'>
                  
                      <div className=''>
                        <span className=' font-black text-[var(--color-primary-gray)]'>
                          Purchasing Agent:
                        </span>
                        <span className='text-[var(--color-primary-gray)] font-bold'>
                          {" "}
                          An automatic email with a unique passcode will be generated. Please forward this email or link to your Purchasing Agent who can then authorize the order and provide payment information. The passcode and link will be valid for 10 calendar days.

                        </span>
                        <br/>
                        <span className="font-bold text-red-500">*Please note that your order will not be processed until we receive the approval from your PA when you choose this payment method.</span>
                    </div>
                  </div>
                </div>
              )}
            </>
            
          </>
          }
          
        </div>
        {errors.billingMethod && <span className="text-[14px] text-red-500 font-bold">{errors.billingMethod}</span>}

		<Bill type={"WPS"} price={orderAmount} changePrice={changePrice} page={"billing"} user={user} wpsDiscount={null} numOfrxns={wpsWhole.data.tableData.length}/>

        <AutoSave
          currentOrderForm={wpsWhole}
          page={page}
          handleNextPage={validateBilling}
          handlePrevPage={handlePrevPage}
          steps={5}
          passMessage={passMessage}
        />
      </div>
    </>
  );
};

export default BillingInformation;
